<app-bread-crumb></app-bread-crumb>

<app-news-info [FunctionID]="this.newsres.FunctionID"></app-news-info>
